import React from 'react';
import { Form, Input, Select, Col, Row, InputNumber, message, Button, Popconfirm, Tooltip } from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {handleExportParams} from "../../../../utils";
import {
    API_Merchant_deleteMerchantSplitAccountInfo,
    API_Merchant_getMerchantSplitAccountInfo,
    API_Merchant_updateMerchantSplitAccountInfo
} from "../../../../axios/config";
import {paymentDate} from "../../../../axios/dictionaries";
import * as PropTypes from "prop-types";


const Option = Select.Option;



class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            merchantId:0,
            title: "分账配置",
            data: {

                houseLayout: [],
                otherCost: [],
                splitAccount: [ {
                    key: 0,
                    splitAccountA:'',
                    splitAccountB:'',
                    splitAccountC:'',
                    splitAccountD:'',
                    splitAccountE:'',
                    splitAccountF:1,
                    splitAccountG: '商户结余账号配置'
                },
                    {
                        key: 1,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:2,
                        splitAccountG: '代付平台云贷费用'
                    },
                    {
                        key: 2,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:3,
                        splitAccountG: '平台服务费用'
                    },
                    {
                        key: 3,
                        splitAccountA:'/',
                        splitAccountB:'/',
                        splitAccountC:'/',
                        splitAccountD:'/',
                        splitAccountE:'/',
                        splitAccountF:4,
                        splitAccountG: '银联手续费'
                    }
                    ,{
                        key: 4,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:6,
                        splitAccountG: '应汇集金额',
                        splitAccountH: ''
                    },{
                        key: 5,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:7,
                        splitAccountG: '电子认证费用',
                        splitAccountH: ''
                    },{
                        key: 6,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:8,
                        splitAccountG: '物业运营服务费',
                        splitAccountH: ''
                    },{
                        key: 7,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:9,
                        splitAccountG: '代付业主租金',
                        splitAccountH: ''
                    },
                ]
            },
        }
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        <Col span={24}>
                            <DetailTitle title="商户结余账号配置(银联资金划付商户资金账户)"/>
                            <CustomRow key={data.splitAccount[0].key}>
                                {getFieldDecorator('splitAccountF0', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[0].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG0`, {
                                    initialValue:  data.splitAccount[0].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA0', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[0].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="收款单位">
                                    {getFieldDecorator('splitAccountB0', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[0].splitAccountB: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="银行账号">
                                    {getFieldDecorator('splitAccountC0', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[0].splitAccountC: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="开户行">
                                {getFieldDecorator('splitAccountD0', {
                                    rules: [{
                                        required: true, message: '请输入',
                                    }],
                                    initialValue:  data.splitAccount instanceof Array ? data.splitAccount[0].splitAccountD: null
                                })(
                                    <Input
                                        placeholder={'请输入'}
                                        autoComplete={'off'}
                                    />
                                )}
                            </CustomCol>
                            </CustomRow>
                            <DetailTitle title="应汇集金额"/>
                            <CustomRow key="4">
                                {getFieldDecorator('splitAccountF4', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[4].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG4`, {
                                    initialValue:  data.splitAccount[4].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="金额">
                                    {getFieldDecorator('splitAccountE4', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:   data.splitAccount instanceof Array ?data.splitAccount[4].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0.01}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="电子认证费用"/>
                            <CustomRow key={data.splitAccount[5].key}>
                                {getFieldDecorator('splitAccountF5', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[5].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG5`, {
                                    initialValue:  data.splitAccount[5].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA5', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[5].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="金额">
                                    {getFieldDecorator('splitAccountE5', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:   data.splitAccount instanceof Array ?data.splitAccount[5].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="执行日">
                                    {getFieldDecorator('splitAccountH5', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount instanceof Array ?data.splitAccount[5].splitAccountH:null
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="物业运营服务费"/>
                            <CustomRow key={data.splitAccount[6].key}>
                                {getFieldDecorator('splitAccountF6', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[6].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG6`, {
                                    initialValue:  data.splitAccount[6].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA6', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[6].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="金额">
                                    {getFieldDecorator('splitAccountE6', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:   data.splitAccount instanceof Array ?data.splitAccount[6].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0.00}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="执行日">
                                    {getFieldDecorator('splitAccountH6', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount instanceof Array ?data.splitAccount[6].splitAccountH:null
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="代付业主租金"/>
                            <CustomRow key={data.splitAccount[7].key}>
                                {getFieldDecorator('splitAccountF7', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[7].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG7`, {
                                    initialValue:  data.splitAccount[7].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA7', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[7].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="执行日">
                                    {getFieldDecorator('splitAccountH7', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount instanceof Array ?data.splitAccount[7].splitAccountH:null
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="专项费用"/>
                            <CustomRow key={data.splitAccount[1].key}>
                                {getFieldDecorator('splitAccountF1', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[1].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG1`, {
                                    initialValue:  data.splitAccount[1].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA1', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[1].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="金额">
                                    {getFieldDecorator('splitAccountE1', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:   data.splitAccount instanceof Array ?data.splitAccount[1].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="执行日">
                                    {getFieldDecorator('splitAccountH1', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount instanceof Array ?data.splitAccount[1].splitAccountH:null
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="平台服务费用"/>
                            <CustomRow key={data.splitAccount[2].key}>
                                {getFieldDecorator('splitAccountF2', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[2].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="商户企业号">
                                    {getFieldDecorator('splitAccountA2', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:  data.splitAccount instanceof Array ? data.splitAccount[2].splitAccountA: null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="金额">
                                    {getFieldDecorator('splitAccountE2', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:data.splitAccount instanceof Array ?data.splitAccount[2].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="执行日">
                                    {getFieldDecorator('splitAccountH2', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount instanceof Array ?data.splitAccount[2].splitAccountH:null
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="银联手续费"/>
                            <CustomRow key={data.splitAccount[3].key}>
                                {getFieldDecorator('splitAccountF3', {
                                    initialValue: data.splitAccount instanceof Array ? data.splitAccount[3].splitAccountF: null
                                })(
                                    <Input type={'hidden'} />
                                )}
                                {getFieldDecorator(`splitAccountG3`, {
                                    initialValue:  data.splitAccount[3].splitAccountG
                                })(
                                    <Input type={'hidden'} />
                                )}
                                <CustomCol label="扣除比例(%)">
                                    {getFieldDecorator('splitAccountE3', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue:data.splitAccount instanceof Array ?data.splitAccount[3].splitAccountE:null
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <DetailTitle title="其他费用配置"/>
                            {
                                data.splitAccount instanceof Array
                                    ? data.splitAccount.map((item, index) => {
                                        return item.splitAccountF != 5 ? null: <CustomRow key={item.key}>
                                            <CustomCol label="费用名称">
                                                {getFieldDecorator(`splitAccountG${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.splitAccountG
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                    />
                                                )}
                                            </CustomCol>
                                            {getFieldDecorator(`splitAccountF${item.key}`, {
                                                initialValue:  item.splitAccountF
                                            })(
                                                <Input type={'hidden'} />
                                            )}
                                            <CustomCol label="商户企业号">
                                                {getFieldDecorator(`splitAccountA${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue:  item.splitAccountA
                                                })(
                                                    <Input
                                                        placeholder={'请输入'}
                                                        autoComplete={'off'}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol label="金额">
                                                {getFieldDecorator(`splitAccountE${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.splitAccountE
                                                })(
                                                    <InputNumber
                                                        placeholder={'请输入'}
                                                        min={0}
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol label="执行日">
                                                {getFieldDecorator(`splitAccountH${item.key}`, {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: item.splitAccountH
                                                })(
                                                    <Select
                                                        showSearch
                                                        placeholder="请选择"
                                                        optionFilterProp={'children'}
                                                    >
                                                        {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                                    </Select>
                                                )}
                                            </CustomCol>
                                            <div style={{display: 'flex', justifyContent: 'center', padding: '5px 0'}}>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        this.handleMinus(index)
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <Button style={{
                                                        marginLeft: '10px',
                                                        marginTop: '-4px',
                                                        width: '34px',
                                                        height: '34px'
                                                    }} shape="circle" icon="minus" />
                                                </Popconfirm>
                                            </div>
                                        </CustomRow>
                                    })
                                    : null

                            }
                            {
                                <div style={{marginTop: '20px', textAlign: 'center'}}>
                                    <Tooltip placement="bottomLeft" title={"添加一行户型输入框"}>
                                        <Button onClick={() => {
                                            this.handlePlus()
                                        }} style={{
                                            width: '40px',
                                            height: '40px',
                                            textAlign: 'center',
                                            lineHeight: '36px',
                                            fontSize: '20px'
                                        }} shape="circle" icon="plus"/>
                                    </Tooltip>
                                </div>
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.splitAccount[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_Merchant_deleteMerchantSplitAccountInfo, data: { splitAccountId: item.id } }).then(res => {
                    data.splitAccount.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.splitAccount.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.splitAccount instanceof Array) {
            if (data.splitAccount.length) {
                data.splitAccount.push({ key: data.splitAccount[data.splitAccount.length - 1].key + 1, splitAccountA: '', splitAccountB: '', splitAccountC: '',splitAccountD:'',splitAccountE:'',splitAccountF: 5,splitAccountG:'',splitAccountH:'' });
            } else {
                data.splitAccount.push({ key: 0, splitAccountA: '', splitAccountB: '', splitAccountC: '',splitAccountD:'',splitAccountE:'',splitAccountF: 5,splitAccountG:'',splitAccountH:'' });
            }
        } else {
            data.splitAccount = [{ key: 0, splitAccountA: '', splitAccountB: '', splitAccountC: '',splitAccountD:'',splitAccountE:'',splitAccountF: 5,splitAccountG:'',splitAccountH:'' }];
        }
        this.setState({ data });
    }

    isNotJr=()=>{
        return handleExportParams().isJr === 2
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {  splitAccount: [ {
                    key: 0,
                    splitAccountA:'',
                    splitAccountB:'',
                    splitAccountC:'',
                    splitAccountD:'',
                    splitAccountE:'',
                    splitAccountF:1,
                    splitAccountG: '商户结余账号配置',
                    splitAccountH: ''
                },
                    {
                        key: 1,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:2,
                        splitAccountG: '代付平台云贷费用',
                        splitAccountH: ''
                    },
                    {
                        key: 2,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:3,
                        splitAccountG: '平台服务费用',
                        splitAccountH: ''
                    },
                    {
                        key: 3,
                        splitAccountA:'/',
                        splitAccountB:'/',
                        splitAccountC:'/',
                        splitAccountD:'/',
                        splitAccountE:'/',
                        splitAccountF:4,
                        splitAccountG: '银联手续费',
                        splitAccountH: ''
                    },
                    {
                        key: 4,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:6,
                        splitAccountG: '应汇集金额',
                        splitAccountH: ''
                    },{
                        key: 5,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:7,
                        splitAccountG: '电子认证费用',
                        splitAccountH: ''
                    },{
                        key: 6,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:8,
                        splitAccountG: '物业运营服务费',
                        splitAccountH: ''
                    },{
                        key: 7,
                        splitAccountA:'',
                        splitAccountB:'',
                        splitAccountC:'',
                        splitAccountD:'',
                        splitAccountE:'',
                        splitAccountF:9,
                        splitAccountG: '代付业主租金',
                        splitAccountH: ''
                    },
                ]}, loading: false, title: "分账配置" });
    }


    loadPack = ({ id }) => {
        this.setState({ loading: true,merchantId: id, title: "分账配置" });

        postFrom({ url: config.API_Merchant_getMerchantSplitAccountInfo, data: { merchantId: id } }).then(res => {
            res.splitAccount = res.splitAccountInfoList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                item = {
                    id: item.id || 0,
                    key:index,
                    splitAccountA: item.enterpriseUserNumber==null?'':item.enterpriseUserNumber,
                    splitAccountB: item.accountName==null?'':item.accountName,
                    splitAccountC: item.accountNumber==null?'':item.accountNumber,
                    splitAccountD: item.bankName==null?'':item.bankName,
                    splitAccountE: item.splitAmount,
                    splitAccountF: item.splitConstType,
                    splitAccountG: item.costName,
                    splitAccountH: item.executionDay
                };
                return item
            });
            //判断是否存在默认的key



            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                let { data: { splitAccount } } = this.state;
                this.setState({ loading: true });

                let valueKeys = Object.keys(values);
                let fKeys = valueKeys.filter((item, index) => { //获取出户型字段
                    if (/^splitAccountF[\d]+$/.test(item)) return item;
                });
                values.splitAccountInfoList = fKeys.map((item, index) => { //处理户型字段
                    let id = splitAccount[index].id;
                    let num = item.slice(13);
                    item = {
                        id: id || 0,
                        enterpriseUserNumber: values[`splitAccountA${num}`],
                        accountName: values[`splitAccountB${num}`],
                        accountNumber: values[`splitAccountC${num}`],
                        bankName: values[`splitAccountD${num}`],
                        splitAmount: values[`splitAccountE${num}`],
                        splitConstType: values[`splitAccountF${num}`],
                        costName: values[`splitAccountG${num}`],
                        executionDay: values[`splitAccountH${num}`],
                    };
                    delete values[`splitAccountA${num}`];
                    delete values[`splitAccountB${num}`];
                    delete values[`splitAccountC${num}`];
                    delete values[`splitAccountD${num}`];
                    delete values[`splitAccountE${num}`];
                    delete values[`splitAccountF${num}`];
                    delete values[`splitAccountG${num}`];
                    delete values[`splitAccountH${num}`];
                    return item
                });
                values.merchantId= this.state.merchantId;
                console.log(values.splitAccount);

                // if (values.id) {
                    post({ url: config.API_Merchant_updateMerchantSplitAccountInfo, data: values }).then(res => {
                        message.success('操作成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '操作失败');
                        this.setState({ loading: false });
                    })

            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Merchant/components/SplitAccountAdd/index.js